// this is set by devops based
export const REACT_APP_ENVIRONMENTS = {
  dev: 'dev',
  staging: 'staging',
  prod: 'prod'
}

export const CHIP_COLORS = {
  neutral: 'neutral',
  warning: 'warning',
  success: 'success',
  error: 'error',
  blue: 'blue'
}

export const TOAST_TYPE = {
  success: 'success',
  error: 'error',
  info: 'info'
}

export const MODAL_TYPE = {
  newCampaignCreated: 'newCampaignCreated',
  newLineItemCreated: 'newLineItemCreated',
  automatedLineItemCreated: 'automatedLineItemCreated',
  rightFacebookAdUploaded: 'rightFacebookAdUploaded',
  rightGoogleAdUploaded: 'rightGoogleAdUploaded',
  rightTikTokAdUploaded: 'rightTikTokAdUploaded',
  rightDV360AdUploaded: 'rightDV360AdUploaded'
}

export const listItemChangeStatus = {
  active: {
    status: 'active',
    changeTo: 'paused',
    changeLabel: 'Pause'
  },
  paused: {
    status: 'paused',
    changeTo: 'active',
    changeLabel: 'Activate'
  }
}

export const facebookListItemInsights = [
  'actions_like',
  'actions_post',
  'actions_post_reaction',
  'clicks',
  'conversions',
  'conversions_value',
  'cpc',
  'cpm',
  'ctr',
  'engagement',
  'frequency',
  'impressions',
  'purchase',
  'reach',
  'roas',
  'spend',
  'lead',
  'video_view_rate',
  'video_views',
  'results'
  // todo PBR-1057 uncomment when failing request is fixed
  // 'complete_registration'
  // 'landing_page_view'
]

export const googleListItemInsights = [
  'active_view_impressions',
  'clicks',
  'conversions',
  'cost_per_conversion',
  'cpc',
  'cpm',
  'ctr',
  'impressions',
  'purchase',
  'roas',
  'spend',
  'video_view_rate',
  'video_views'
]

export const dv360ListItemInsights = [
  'clicks',
  'cpc',
  'cpm',
  'ctr',
  'impressions',
  'purchase',
  'spend',
  'video_view_rate',
  'video_views'
]

export const tikTokListItemInsights = [
  'clicks',
  'cpc',
  'cpm',
  'ctr',
  'engagement',
  'frequency',
  'impressions',
  'purchase',
  'reach',
  'roas',
  'spend',
  'video_view_rate',
  'video_views'
]
export const defaultEventColor = '#314D96'
export const eventColors = [
  '#FF4B55',
  '#FF7D97',
  '#C837AB',
  '#7958BE',
  '#6CF5C2',
  '#1778F2',
  '#A7E8A6',
  '#34A853',
  '#AE8A21',
  '#FEE45A',
  '#F9CF48',
  '#FEA02C',
  '#B11010',
  defaultEventColor,
  '#E5E5E5',
  '#929292',
  '#555555',
  '#000000'
]

// value metrics names
export const PURCHASES_ROAS = 'Purchases (ROAS)'

// ListItem types
export const LIST_ITEM_CAMPAIGN = 'list_item_campaign'
export const LIST_ITEM_LINE_ITEM = 'list_item_line_item'
export const LIST_ITEM_AD = 'list_item_ad'

// invite types which come from 't' query param on /accept-invite page
export const USER_INVITE = 'i'
export const BETA_INVITE = 'bi'

// tasks processing states (useTasksProcessing hook)
export const PROCESS = 'process'
export const SUCCESS = 'success'
export const ERROR = 'error'
export const INVISIBLE_SKIP = 'invisible_skip'
